import React from "react";

import "../Input/styles.css";

function isFieldError(array, val) {
	return array.includes(val);
}

const InputUncontrolled = ({
	type,
	label,
	note = "",
	req,
	name,
	value,
	errors,
	autocomplete = "off",
}) => {
	return (
		<div className="input">
			<label htmlFor={name} className={!label ? "hidden" : ""}>
				{`${label}`} {req ? <span className="error">*</span> : null}
			</label>
			<input
				type={type}
				name={name}
				id={name}
				defaultValue={value}
				autoComplete={autocomplete}
				className={isFieldError(errors, name) ? "error-border" : ""}
			/>
			<small className={note ? "" : "hidden"}>{note}</small>
		</div>
	);
};

export default InputUncontrolled;
